module.exports = __webpack_public_path__ + "static/img/observe-home-img.70b796ff.png";